<template>

    <v-container fluid fill-height>

        <v-layout align-center justify-center>

            <v-flex xs12 sm8 md4>

                <v-card class="elevation-12">

                    <v-toolbar dark color="primary">

                        <v-toolbar-title>Login form</v-toolbar-title>
                        <v-spacer></v-spacer>

                    </v-toolbar>

                    <v-card-text>

                        <v-form>
                            <v-text-field prepend-icon="person" label="Login" type="email" name="email" v-model="email" :error="error_messages != false" :error-messages="error_messages" @keyup.enter="login()"></v-text-field>
                            <v-text-field id="password" prepend-icon="lock" label="Password" name="password" type="password" v-model="password" @keyup.enter="login()"></v-text-field>
                        </v-form>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="login()">Login</v-btn>
                    </v-card-actions>

                </v-card>

            </v-flex>

        </v-layout>

    </v-container>

</template>

<script>
    export default{
        data(){
            return {
                email: '',
                password: '',
                error_messages: [],
            }
        },
        methods: {
            login(){
                this.resetErrors();
                let data = {
                    client_id: 2,
                    client_secret: 'ljxxUEkedCZFvnorQw2LZ5YZRSWFRBTC3pAK1zB3',
                    grant_type: 'password',
                    username: this.email,
                    password: this.password
                };
                axios.post(process.env.VUE_APP_API + 'oauth/token', data)
                    .then( res => {
                        this.$auth.setToken(res.data.access_token, res.data.expires_in + Date.now(), res.data.refresh_token);
                        this.storeUser();
                    })
                    .catch( e => {
                        console.log(e.response.data);
                        this.error_messages = e.response.data.error;
                    });
            },
            resetErrors(){
                this.error_messages = [];
            },
            /** auth **/
            storeUser(){
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$auth.getToken();
                if(this.$store.getters['user/getUser'] == null){
                    axios.get(process.env.VUE_APP_API + 'user')
                        .then(res => {
                            this.$store.dispatch('user/changeUser', res.data.user);
                            this.$store.dispatch('nav/setShowLeftBar', true);
                            this.$store.dispatch('ability/changePermissionList', res.data.permissions);

                            // defineAbilitiesFor(this.$store.getters['ability/getPermissionList']);
                            this.loading = false;
                            this.$router.push('/');
                        })
                        .catch(e => {
                            if(e.response.status == 401){
                                this.$auth.destroyToken();
                                this.$router.push('/login');
                            }
                        });
                }
            },
        },
    }
</script>
